export default __webpack_public_path__ + "static/media/gallery-wip-head-pins_02.76b2ddd1.jpg";